import { observer } from 'mobx-react-lite'
import { ForfeitDialog } from '@/features/jobs/details/components/ForfeitDialog'
import { useFeatures } from '@/contexts/root-store-context'
import { type ForfeitDialogViewModel } from './ForfeitDialogViewModel'

export interface ForfeitDialogContainerProps {
  vm: ForfeitDialogViewModel
}

export const ForfeitDialogContainer = observer(function ForfeitDialogContainer({
  vm,
}: ForfeitDialogContainerProps) {
  const { shellInfo } = useFeatures(({ shell }) => ({
    shellInfo: shell.shellInfo,
  }))
  return (
    <ForfeitDialog
      showing={vm.modal.showing}
      onClose={vm.modal.close}
      onForfeit={vm.forfeit}
      isForfeitPending={vm.forfeit.pending}
      corporateMode={shellInfo.corporateMode}
    />
  )
})
